import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7bbcf61e"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-background" }, null, -1))
const _hoisted_2 = { class: "modal-content box" }
const _hoisted_3 = { class: "title-five mb-3" }
const _hoisted_4 = { class: "progress-container" }
const _hoisted_5 = { class: "progress-value" }

import { computed, PropType, ref, watch } from 'vue'
import { onBeforeRouteLeave, RouteLocationNormalized, useRouter } from 'vue-router'
import { notify } from '@kyvg/vue3-notification'
import i18n from '@/locales'

/*
 * Modal becomes active when percentage is 0-100; it will remain
 * on screen for an additional 750ms. A nav away route guard is
 * active while the modal is active.
 *
 * TIPS
 *  - Use null for initial value
 *  - Use percentage-value 0 before any upload
 *  - Do not reset percentage after each upload
 *
 * Tip #2 is important for fast uploads; percentage can jump to
 * 100 quickly. Tip #3 is necessary to observe the 750ms delay.
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'UploadProgress',
  props: {
  percentage: {
    type: Number as PropType<number | null>,
    default: null
  },
  title: String,
},
  setup(__props) {

const props = __props

const hasDelayedCloseFinished = ref(false)
const router = useRouter()

let delayedRouteNavTo: RouteLocationNormalized|null = null

const showModal = computed(() => {
  return props.percentage !== null &&
    props.percentage <= 100 &&
    props.percentage >= 0 &&
    !hasDelayedCloseFinished.value
})
const widthStyle = computed(() => {
  return { 'width': (props.percentage ?? 0) + '%' }
})

watch(
  () => props.percentage,
  value => {
    if (value === 100) {
      setTimeout(
        () => {
          hasDelayedCloseFinished.value = true
          if (delayedRouteNavTo !== null) {
            router.push(delayedRouteNavTo)
          }
        },
        750
      )
    } else {
      hasDelayedCloseFinished.value = false
    }
  },
  { immediate: true }
)

onBeforeRouteLeave((to) => {
  if (showModal.value) {
    if (delayedRouteNavTo === null) {
      delayedRouteNavTo = to
    } else if (delayedRouteNavTo.fullPath !== to.fullPath && props.percentage === 100) {
      /*
       * If a destination already exists, reject other navigation requests,
       * like from PageCreator to PageEditor.
       */
      return false
    }

    if (props.percentage !== null && props.percentage < 100) {
      notify({
        title: i18n.global.t('itemInProgress', {item: i18n.global.t('upload')}),
        text: i18n.global.t('waitForUpload'),
        type: 'warn',
        duration: 5000
      })
    }

    // reject navigation if modal is active
    return false
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["modal", { 'is-active': showModal.value }])
  }, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h5", _hoisted_3, _toDisplayString(__props.title ?? _ctx.$t('fileUpload')), 1),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", {
          class: "progress",
          style: _normalizeStyle(widthStyle.value)
        }, null, 4),
        _createElementVNode("p", _hoisted_5, _toDisplayString(__props.percentage ?? 0) + " %", 1)
      ])
    ])
  ], 2))
}
}

})